<div :class="'delimiter' + (options?.class ? ' ' + options.class : '')" v-html="title" />
